export default function LoadingScreen() {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <span className="flex h-12 w-12">
        <span className="animate-ping absolute inline-flex h-12 w-12 rounded-full bg-secondary opacity-75"></span>
      </span>
    </div>
  );
}
